import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import "react-datepicker/dist/react-datepicker.css";
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";

 // app config
 import AppConfig from 'Constants/AppConfig';
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import { RctCard, RctCardContent } from 'Components/RctCard/index';


import { 
    fetchPlayerFsDriver,
    fetchFSDriver,
    deleteFSDriver
 } from 'Actions';

 import AddItem from '../../../technologyreport/fsdriver/component/addform';
 import EditItem from '../../../technologyreport/fsdriver/component/editform';

 import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
 import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
 import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

class FsdriverItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,

    };

    UNSAFE_componentWillMount() {
	}
    constructor(props) {
      
        super(props);
        this.confirmationDialog = React.createRef();
        this.state = {  
            student: this.props.data.student, 
            startdate:this.props.data.startdate,
            enddate:this.props.data.enddate,
            listdiv:true,
            reportdiv:false,
            allreports:[],
            filecnt:0,
            adddiv:false,
            frmreport:this.props.data.frmreport,
            editdiv:false,
            alllstdiv1:false,
            eid:'',   
            clubform: [],
            cntclub:1,
            ballform: [],
            cntball:1,
            rateform: [],
            cntrate:1,
            smashform: [],
            cntsmash:1,            
            carryform: [],
            cntcry:1,
            aoaform: [],
            cntaoa:1,
            pathform: [],
            cntpath:1,
            hspform: [],
            cnthsp:1,
            ftpform: [],
            cntftp:1,
            fttform: [],
            cntftt:1, 
        };

        this.onPrevSection = this.onPrevSection.bind(this); 
        this.onBacksection = this.onBacksection.bind(this); 
        this.onAddSession = this.onAddSession.bind(this);
        this.onListSession = this.onListSession.bind(this); 
        this.deleteForm = this.deleteForm.bind(this); 
    }

    

    onPrevSection(){
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        this.props.fetchPlayerFsDriver(student, stdate, eddate);

        this.setState({
            reportdiv:false,
            adddiv:false,
            alllstdiv1:false,
            listdiv:true, 
        }); 
    }

    onAddSession() {
        
		this.setState({ 
         listdiv:false,
         adddiv:true,
      });
    }
    
    onListSession() {   

		this.setState({ 
         sellst:1,   
         alllstdiv1:true,   
         listdiv:false,
         adddiv:false,
      });
    }

    onBacksection(){
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        this.props.fetchPlayerFsDriver(student, stdate, eddate);

        this.setState({ 
            alllstdiv1:false,  
            editdiv:false,
            adddiv:false,
            reportdiv:false,
            listdiv:true
        });
    }

    editAssessment(gid){
        this.props.fetchFSDriver(gid).then((data) => {   
            var resdata=data.data;
            var allclub=resdata[0].gfs_clsp.split(",");
            var trclubobj=[]; 
            var trclubcnt=1;
            if(allclub.length!=0){
               {allclub.map((teamval) => (   
                  trclubobj.push({
                     club: teamval
                  })
               ))}
               trclubcnt=allclub.length;
            }else{
               trclubobj.push({
                  club: ''
               })
            }

            var allball=resdata[0].gfs_basp.split(",");
            var trballobj=[]; 
            var trballcnt=1;
            if(allball.length!=0){
               {allball.map((teamval) => (   
                  trballobj.push({
                     ball: teamval
                  })
               ))}
               trballcnt=allball.length;
            }else{
               trballobj.push({
                  ball: ''
               })
            }

            var allsmash=resdata[0].gfs_smash.split(",");
            var trsmashobj=[]; 
            var trsmashcnt=1;
            if(allsmash.length!=0){
               {allsmash.map((teamval) => (   
                  trsmashobj.push({
                     smash: teamval
                  })
               ))}
               trsmashcnt=allsmash.length;
            }else{
               trsmashobj.push({
                  smash: ''
               })
            }

            var allrate=resdata[0].gfs_sprt.split(",");
            var trrateobj=[]; 
            var trratecnt=1;
            if(allrate.length!=0){
               {allrate.map((teamval) => (   
                  trrateobj.push({
                     rate: teamval
                  })
               ))}
               trratecnt=allrate.length;
            }else{
               trrateobj.push({
                  rate: ''
               })
            } 
            
            var allcarry=resdata[0].gfs_carry.split(",");
            var trcryobj=[]; 
            var trcrycnt=1;
            if(allcarry.length!=0){
               {allcarry.map((teamval) => (   
                  trcryobj.push({
                     carry: teamval
                  })
               ))}
               trcrycnt=allcarry.length;
            }else{
               trcryobj.push({
                  carry: ''
               })
            }

            var allaoa=resdata[0].gfs_aoa.split(",");
            var traoaobj=[]; 
            var traoacnt=1;
            if(allaoa.length!=0){
               {allaoa.map((teamval) => (   
                  traoaobj.push({
                     aoa: teamval
                  })
               ))}
               traoacnt=allaoa.length;
            }else{
               traoaobj.push({
                  aoa: ''
               })
            }
            
            var allpath=resdata[0].gfs_path.split(",");
            var trpathobj=[]; 
            var trpathcnt=1;
            if(allpath.length!=0){
               {allpath.map((teamval) => (   
                  trpathobj.push({
                     path: teamval
                  })
               ))}
               trpathcnt=allpath.length;
            }else{
               trpathobj.push({
                  path: ''
               })
            }

            var allhsp=resdata[0].gfs_hsp.split(",");
            var trhspobj=[]; 
            var trhspcnt=1;
            if(allhsp.length!=0){
               {allhsp.map((teamval) => (   
                  trhspobj.push({
                     hsp: teamval
                  })
               ))}
               trhspcnt=allhsp.length;
            }else{
               trhspobj.push({
                  hsp: ''
               })
            }

            var allftp=resdata[0].gfs_ftp.split(",");
            var trftpobj=[]; 
            var trftpcnt=1;
            if(allftp.length!=0){
               {allftp.map((teamval) => (   
                  trftpobj.push({
                     ftp: teamval
                  })
               ))}
               trftpcnt=allftp.length;
            }else{
               trftpobj.push({
                  ftp: ''
               })
            }

            var allftt=resdata[0].gfs_ftt.split(",");
            var trfttobj=[]; 
            var trfttcnt=1;
            if(allftt.length!=0){
               {allftt.map((teamval) => (   
                  trfttobj.push({
                     ftt: teamval
                  })
               ))}
               trfttcnt=allftt.length;
            }else{
               trfttobj.push({
                  ftt: ''
               })
            }

            this.setState({ 
               seldate:resdata[0].gfs_date,  
               student:resdata[0].gfs_userID, 
               eid:resdata[0].gfsID,   
               carryform: trcryobj,
               cntcry:trcrycnt, 
               clubform: trclubobj,
               cntclub:trclubcnt,  
               ballform: trballobj,
               cntball:trballcnt,  
               rateform:trrateobj,
               cntrate:trratecnt,
               smashform:trsmashobj,
               cntsmash:trsmashcnt,
               aoaform:traoaobj,
               cntaoa:traoacnt,
               pathform:trpathobj,
               cntpath:trpathcnt,
               hspform:trhspobj,
               cnthsp:trhspcnt,
               ftpform:trftpobj,
               cntftp:trftpcnt,
               fttform:trfttobj,
               cntftt:trfttcnt,       
           });


            this.setState({ 
                viewdiv:false,               
                adddiv:false,
                alllstdiv1:false, 
                editdiv:true,
       
              });

        });
    }

    deleteForm(data){
      this.data = data;
      this.student=this.state.student;
      this.confirmationDialog.current.openDialog();
    }

    deleteDataPermanent(popupResponse){
      
        if (popupResponse) {
            this.props.deleteFSDriver(this.data);
            var student=this.student;
            this.props.fetchPlayerFsDriver(student, '', '');
        }
    }



render() {
      
    const { playertechfsdriver, loading} = this.props; 
    const stdrole = localStorage.getItem('stdrole');
    const options = {
        filterType: 'dropdown',
        rowsPerPage: 50,
        rowsPerPageOptions: [50, 100, 150],
        selectableRowsHideCheckboxes: true,
    };

    const columns = [
        { name: "no", label: "NO" },
        { name: "name", label: "NAME" },
        { name: "cdate", label: "DATE" },
        { name: "action", label: "ACTION" },
        { name: "action1", label: "ACTION1" },
      
    ];
    const tabledata=playertechfsdriver.map((assmntval,idx) => {     
                 const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval.gfsID)}><EditOutlinedIcon/></IconButton>;
                 const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval.gfsID)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
            
            return {
            no:idx+1,
            name: assmntval.student,
            cdate: assmntval.cdate,
            action: ebtn,
            action1:dbtn,
            
            }
    });  
    const styles = {
        table: {
            border: "2px solid rgb(0, 0, 0)",
            borderColor:"rgb(0 0 0 / 49%)",
            borderStyle:"solid",
            color:"#000"
        },
        tabletrtd: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            fontWeight: "500"
        },
        tabletrtdleft:{
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px"
        },
        tabletrtdhead:{
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            fontWeight:"bold",
            textAlign:"center"
        }
    }; 

      return(
            <div>
                <div className="col-md-12 col-lg-12 col-sm-12">
                    <h1 className="text-center" style={{padding:"20px"}}> FS DRIVER </h1>
                </div>
                <div className="col-md-12 col-lg-12 col-sm-12" style={{marginBottom:"10px"}}>
                    <div className="ddd">
                        {stdrole==0 ? <div className="float-left"><a onClick={this.onAddSession} style={{color:"blue"}}><span class="icon-plus"></span> Add</a> <a style={{color:"orange", paddingLeft:"10px"}} onClick={this.onListSession}><span class="icon-list"></span> List</a></div>:''}
                        <div className="float-right"><Button onClick={this.props.onClick} className="btn btn-outline-warning"><KeyboardDoubleArrowLeftIcon aria-hidden="true" />  Back To Technology</Button></div>
                        {this.state.frmreport==1?<div className="float-left"><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Report</Button></div>:''}
                    </div>
                </div>
                {this.state.listdiv && 
                    <div className="shop-grid">
                        <div className="row">
                        {playertechfsdriver.map((product, key) => (
                            <div className="col-sm-6 col-md-4 col-xl-3" key={key}>
                                <RctCard>
                                    <RctCardContent>
                                    
                                    <div className="rpoduct-detail">
                                        <h2 className="text-center">{product.cdate}</h2>
                                        {/* <h4 className="mb-15 text-center">{product.student}</h4> */}
                                        <div className="table-responsive">
                                        <table className="table align-items-center table-flush" style={styles.table}>  
                                        <tbody>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>CLUB SPEED</td>
                                                <td style={styles.tabletrtd}><strong>{product.clubspeed}</strong></td>
                                            </tr> 
                                            <tr>
                                                <td style={styles.tabletrtdleft}>BALL SPEED</td>
                                                <td style={styles.tabletrtd}><strong>{product.ballspeed}</strong></td>
                                            </tr> 
                                            <tr>
                                                <td style={styles.tabletrtdleft}>SPIN RATE</td>
                                                <td style={styles.tabletrtd}><strong>{product.spinrate}</strong></td>
                                            </tr> 
                                            <tr>
                                                <td style={styles.tabletrtdleft}>SMASH</td>
                                                <td style={styles.tabletrtd}><strong>{product.smash}</strong></td>
                                            </tr> 
                                            <tr>
                                                <td style={styles.tabletrtdleft}>CARRY</td>
                                                <td style={styles.tabletrtd}><strong>{product.carry}</strong></td>
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>AOA</td>
                                                <td style={styles.tabletrtd}><strong>{product.aoa}</strong></td>
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>PATH</td>
                                                <td style={styles.tabletrtd}><strong>{product.path}</strong></td>
                                            </tr> 
                                            <tr>
                                                <td style={styles.tabletrtdleft}>HSP</td>
                                                <td style={styles.tabletrtd}><strong>{product.hsp}</strong></td>
                                            </tr> 
                                            <tr>
                                                <td style={styles.tabletrtdleft}>FTP</td>
                                                <td style={styles.tabletrtd}><strong>{product.ftp}</strong></td>
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>FTT</td>
                                                <td style={styles.tabletrtd}><strong>{product.ftt}</strong></td>
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>INFERENCE</td>
                                                <td style={styles.tabletrtd}>{product.gfs_inference}</td>
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>NOTES</td>
                                                <td style={styles.tabletrtd}>{product.gfs_notes}</td>
                                            </tr>    
                                        </tbody>
                                        </table>  
                                        </div> 
                                    </div>
                                    </RctCardContent>
                                </RctCard>
                            </div>
                        ))}
                        </div>
                    </div>
                }
                {this.state.alllstdiv1 &&
                    <div className="col-sm-12 col-lg-10" style={{margin:"0 auto"}}>
                        <RctCollapsibleCard heading="List" backtoadd onClick={this.onPrevSection} fullBlock>
                            <MUIDataTable
                                data={tabledata}
                                columns={columns}
                                options={options}
                            />
                        </RctCollapsibleCard>
                    </div>
                }

                {this.state.adddiv &&
                   <AddItem onClick={this.onPrevSection} data={this.state}/> 
                }

                {this.state.editdiv &&
                    <EditItem onClick={this.onBacksection} data={this.state}/>
                }

                <ConfirmationDialog
                ref={this.confirmationDialog}
                onConfirm={(res) => this.deleteDataPermanent(res)}
                data={'FS Driver'}
                />
            </div>

              
    )
   
}
 
}

const mapStateToProps = ({ playerintervention}) => {
   
    const { playertechfsdriver, loading } = playerintervention;    
    return { playertechfsdriver, loading };   
}


export default connect(mapStateToProps, {
    fetchPlayerFsDriver,
    fetchFSDriver,
    deleteFSDriver
})(FsdriverItems);
